import { RD_BASE } from './config';

// ── 社交叙事信号（LunarCrush via Railway）────────────
export async function fetchSocialSignals(tokenSymbol) {
  if (!tokenSymbol) return null;
  try {
    const res = await fetch(`${RD_BASE}/social/signals?symbol=${encodeURIComponent(tokenSymbol)}`, { signal: AbortSignal.timeout(5000) });
    if (!res.ok) return null;
    const json = await res.json();
    const c = json.data;
    if (!c) return null;
    return {
      galaxyScore:      c.galaxy_score      ?? null,   // 0-100 综合健康分
      altRank:          c.alt_rank          ?? null,   // 社交活跃 vs 市值排名
      socialVolume:     c.social_volume     ?? null,   // 24h 社交提及量
      socialDominance:  c.social_dominance  ?? null,   // 占全加密社交 % 份额
      sentiment:        c.sentiment         ?? null,   // 0-100，>50 偏多
    };
  } catch { return null; }
}
